export default __webpack_public_path__ + "static/media/touch-cursor-point.062facbe.svg";